import { unescape } from 'querystring';
import { Component, Input, ViewChild } from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { CropperSettings, ImageCropperComponent } from 'ng2-img-cropper';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';

@Component({
    templateUrl: './upload-logo.component.html',
    styleUrls: ['./upload-logo.component.css']
})

/**
 * Component for uploading an entity's logo.
 */
export class UploadLogoComponent {
    enableSubmitButton = false;
    fileEvent: any;
    searchPlaceholder = MessageService.CLIENT_SEARCH_PLACEHOLDER;
    @Input() entityId: number;
    @ViewChild('cropper', undefined)
    cropper: ImageCropperComponent;
    image: string;
    data: any;
    cropperSettings: CropperSettings;

    constructor(
        public dialogRef: MdDialogRef<UploadLogoComponent>,
        private snackBarService: SnackBarService,
        private cookieService: CookieService) {
        this.cropperSettings = new CropperSettings();
        this.cropperSettings.width = 150;
        this.cropperSettings.height = 150;
        this.cropperSettings.canvasWidth = 440;
        this.cropperSettings.canvasHeight = 250;
        this.cropperSettings.noFileInput = true;

        this.data = {};
    }

    fileChange(event) {
        this.fileEvent = event;
        this.enableSubmitButton = this.entityId != null;
        const image: any = new Image();
        const file: File = event.target.files[0];
        const myReader: FileReader = new FileReader();
        const that = this;
        myReader.onloadend = function (loadEvent: any) {
            image.src = loadEvent.target.result;
            that.cropper.setImage(image);

        };
        myReader.readAsDataURL(file);
    }

    /**
     * This is not the ideal way to upload the file. This code is written to support the jersey 1.X version on backend.
     * Because when we use the http module of angular 2 then it doesn't send the boundary content type in request and it
     * results into 500 and 400 request on backend.
     */
    uploadFile() {
        const fileList: FileList = this.fileEvent.target.files;
        if (fileList.length > 0) {
            const file: File = fileList[0];

            const formData: FormData = new FormData();
            const blob = this.convertBase64ToBlob(this.data.image);
            const fileUpdate = new File([blob], file.name, { type: 'image/png' });

            formData.append('uploadFile', fileUpdate, file.name);
            formData.append('entityId', String(this.entityId));

            const url = ConstantsService.APP_BE_URL + '/rest/relationentity/image';
            const xhr: XMLHttpRequest = new XMLHttpRequest();
            const response = {
                flagResult: false,
                message: ''
            };
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        response.flagResult = true;
                        this.callSnackBarService(response);
                        this.enableSubmitButton = false;
                        this.dialogRef.close(this.data.image);
                    } else {
                        this.callSnackBarService(response);
                    }
                }
            };

            xhr.open('POST', url, true);
            xhr.setRequestHeader('Authorization',
                'Bearer ' + this.cookieService.get(ConstantsService.COOKIE_ACCESS_TOKEN));
            xhr.setRequestHeader('app-type', 'TRUST');
            xhr.send(formData);
        }
    }

    private convertBase64ToBlob(base64Image) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString;
        if (base64Image.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(base64Image.split(',')[1]);
        } else {
            byteString = unescape(base64Image.split(',')[1]);
        }

        // separate out the mime component
        const mimeString = base64Image.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });

    }

    private callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.UPLOAD_LOGO_SUCCESS,
            MessageService.UPLOAD_LOGO_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/uploadlogo/upload-logo.component.ts